import React, {useEffect, useRef, useState} from 'react';
import {Surcouche} from './CarteLeaflet.js';
import {IconeCalques} from './CarteUi.js';
import {NAVY} from '../../tokens.js';

const trace = (enfants) => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">{enfants}</svg>
);

const STYLES = [
    {id: 'abribacs', libelle: 'Abribacs', icone: trace(<><path d="M5 9c0-2 3-3.5 7-3.5s7 1.5 7 3.5v10H5z"/><path d="M3 20h18"/></>)},
    {id: 'points', libelle: 'Points par état', icone: trace(<circle cx="12" cy="12" r="5"/>)},
    {id: 'clusters', libelle: 'Clusters au dézoom', icone: trace(<><circle cx="9" cy="10" r="6"/><circle cx="17" cy="16" r="4"/></>)},
    {id: 'grille', libelle: 'Grille (carrés 500 m)', icone: trace(<><rect x="4" y="4" width="7" height="7"/><rect x="13" y="4" width="7" height="7"/><rect x="4" y="13" width="7" height="7"/><rect x="13" y="13" width="7" height="7"/></>)},
    {id: 'heatmap', libelle: 'Heatmap des défauts', icone: trace(<path d="M12 3c2 4 6 6 6 11a6 6 0 0 1-12 0c0-3 2-4 2-6 1 1 2 2 2 4 1-3 2-5 2-9z"/>)},
    {id: 'aplat', libelle: 'Aplat par commune (taux)', icone: trace(<path d="M4 6l6-2 5 3 5-1v12l-5 1-5-3-6 2z"/>)},
    // Lot 8 : disponible uniquement en acte collecte.
    {id: 'tonnage', libelle: 'Remplissage moyen (collecte)', icone: trace(<path d="M12 3c2 4 6 6 6 11a6 6 0 0 1-12 0c0-3 2-4 2-6 1 1 2 2 2 4 1-3 2-5 2-9z"/>), acte: 'collecte'},
];
const FONDS = [{id: 'plan', libelle: 'Plan clair'}, {id: 'photo', libelle: 'Photo aérienne'}];

const TITRE = {padding: '10px 14px 6px', fontSize: 11, fontWeight: 700, letterSpacing: '.12em', textTransform: 'uppercase', color: '#8A929C', borderBottom: '1px solid #EEF1F4'};

/** R7 : bouton `Calques` + popover (style des PAV, fond, limites de communes). Écrit `style`, `fond`, `communes`, `circuits` du permalien. */
export default function CarteCalques({acte, style, fond, communes, circuits, onStyle, onFond, onCommunes, onCircuits}) {
    const [ouvert, setOuvert] = useState(false);
    const racine = useRef(null);

    useEffect(() => {
        if (!ouvert) return undefined;
        const surTouche = (e) => { if (e.key === 'Escape') setOuvert(false); };
        window.addEventListener('keydown', surTouche);
        return () => window.removeEventListener('keydown', surTouche);
    }, [ouvert]);

    const ligne = (actif) => ({display: 'flex', alignItems: 'center', gap: 10, padding: '7px 14px', cursor: 'pointer', background: actif ? '#E6EAF5' : 'transparent', fontWeight: actif ? 600 : 400});

    return (
        <>
            <Surcouche style={{right: 16, top: 134}}>
                <button
                    ref={racine}
                    type="button"
                    aria-label="Calques et style"
                    aria-expanded={ouvert}
                    onClick={() => setOuvert((o) => !o)}
                    style={{width: 36, height: 36, border: `1px solid ${NAVY}`, borderRadius: 999, background: ouvert ? NAVY : '#FFFFFF', color: ouvert ? '#FFFFFF' : NAVY, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer'}}
                >
                    {IconeCalques}
                </button>
            </Surcouche>
            {ouvert && (
                <Surcouche
                    role="group"
                    aria-label="Calques et style"
                    style={{right: 60, top: 134, width: 232, background: '#FFFFFF', border: '1px solid #D5DAE1', borderRadius: 16, boxShadow: '0 8px 24px rgba(16,46,105,.16)', display: 'flex', flexDirection: 'column', fontSize: 13, color: '#2D333B'}}
                >
                    <div style={TITRE}>Style des PAV</div>
                    {STYLES.filter((s) => !s.acte || s.acte === acte).map((s) => (
                        <label key={s.id} style={ligne(style === s.id)}>
                            <input type="radio" name="carte-style" checked={style === s.id} onChange={() => onStyle(s.id)} style={{margin: 0, accentColor: NAVY}}/>
                            {s.icone}{s.libelle}
                        </label>
                    ))}
                    <div style={{...TITRE, marginTop: 4, borderTop: '1px solid #EEF1F4'}}>Fond et surcouches</div>
                    {FONDS.map((f) => (
                        <label key={f.id} style={ligne(false)}>
                            <input type="radio" name="carte-fond" checked={fond === f.id} onChange={() => onFond(f.id)} style={{margin: 0, accentColor: NAVY}}/>
                            {f.libelle}
                        </label>
                    ))}
                    <label style={ligne(false)}>
                        <input type="checkbox" checked={!!communes} onChange={(e) => onCommunes(e.target.checked)} style={{margin: 0, accentColor: NAVY}}/>
                        Limites de communes
                    </label>
                    <label style={{...ligne(false), paddingBottom: 12}}>
                        <input type="checkbox" checked={!!circuits} onChange={(e) => onCircuits(e.target.checked)} style={{margin: 0, accentColor: NAVY}}/>
                        Circuits
                    </label>
                </Surcouche>
            )}
        </>
    );
}
